import React, { Component } from "react";
import { Form } from "react-bootstrap";
import _ from "lodash";
import { us_states } from "../helpers/us_states";

var StatesWidget = function StatesWidget(props) {
  var _$get = _.get(props, "schema", {}),
      title = _$get.title;

  var state_abbreviations = Object.keys(us_states);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Label, null, title), /*#__PURE__*/React.createElement("select", {
    id: props.id,
    className: "form-control",
    value: props.value,
    required: props.required,
    onChange: function onChange(event) {
      return props.onChange(event.target.value);
    },
    disabled: props.disabled,
    readOnly: props.readonly
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, " "), state_abbreviations.map(function (state) {
    return /*#__PURE__*/React.createElement("option", {
      key: state,
      value: state
    }, state);
  })));
};

export default StatesWidget;